import * as React from 'react';
import { Grid, Typography, /*GridList,*/ IconButton } from '@material-ui/core';
import * as PropTypes from 'prop-types';
import { getCurrentUrl } from 'src/effects/utils/common';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import NutriDashReport2013 from '../../assets/images/NutriDashReport2013.png';
import NutriDashReport2014 from '../../assets/images/NutriDashReport2014.png';
import NutriDashReport2015 from '../../assets/images/NutridashReport2015.png';
import NutriDashReport2017 from '../../assets/images/NutriDashReport2017.png';
import NutriDashReport2018 from '../../assets/images/NutriDashReport2018.png';
import { downloadOtherDocumentsPdf } from 'src/effects/api/api.report';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import SurveyReportsPageHeaderComponent from 'src/components/reports/SurveyReportsPageHeaderComponent';


export default class SurveyInternalReportsListComponent extends React.Component<any, any> {

    static contextTypes = {
        router: PropTypes.object
    }

    state = {
        spacing: '16',
        reportIframeSrc: '',
        reportNameList: [],
        isActive: [false, false, false, false, false, false],
        isActiveDiv: true,
        loggedInUSer: {}
    };

    constructor(props: any) {
        super(props);
        this.redirectToReport = this.redirectToReport.bind(this);
        this.back = this.back.bind(this);
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const reportId = parseInt(splitUrl[splitUrl.length - 1], 10);
            this.setState({
                reportIframeSrc: this.getReportIframeSrc(reportId)
            });
        });

        this.setState({
            loggedInUSer:getLocalStorageValue('user')
        
        })

        this.setState({
            reportNameList: [
                {
                    id: 7,
                    reportName: "Download Reports"
                },]
        })
        this.setState((prevState: any) => {
            const newItems = [prevState.isActive];
            newItems[1] = !newItems[1];
            return { isActive: newItems };
        });
    }

    back() {
        this.setState({ isActiveDiv: true });
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const reportId = parseInt(splitUrl[splitUrl.length - 1], 10);
            this.setState({
                reportIframeSrc: this.getReportIframeSrc(reportId)
            });
        });
    }

    handleDownloadOtherDocuments(reportId: any) {
        downloadOtherDocumentsPdf(reportId);
    }


    redirectToReport(reportId: any) {
        this.setState((prevState: any) => {
            const newItems = [prevState.isActive];
            newItems[reportId] = !newItems[reportId];
            return { isActive: newItems };
        });

        this.setState({
            reportIframeSrc: this.getReportIframeSrc(reportId)
        });
    }
    getReportIframeSrc(reportId: any) {
        let reportIframeSrc = "";

        switch (reportId) {
            case 1:
                {
                    reportIframeSrc = 'https://app.powerbi.com/view?r=eyJrIjoiZmE1NjU5ZGUtNTA4Ny00MGEyLWEzMmUtZmEwM2IzYTZmZGU5IiwidCI6Ijc3NDEwMTk1LTE0ZTEtNGZiOC05MDRiLWFiMTg5MjAyMzY2NyIsImMiOjh9';
                }
                break;           
            case 7:
                {
                    reportIframeSrc = "OtherDocument";
                    this.setState({ isActiveDiv: false });
                }
                break; 
            default:
                {
                    reportIframeSrc = 'https://app.powerbi.com/view?r=eyJrIjoiZmE1NjU5ZGUtNTA4Ny00MGEyLWEzMmUtZmEwM2IzYTZmZGU5IiwidCI6Ijc3NDEwMTk1LTE0ZTEtNGZiOC05MDRiLWFiMTg5MjAyMzY2NyIsImMiOjh9';
                }
                break;
        }
        return reportIframeSrc;
    }
    render() {


        return (

            <>
                <div>{
                    this.state.isActiveDiv ?
                        <>
                           
                            <SurveyReportsPageHeaderComponent/>

                            <div className="pageContent">
                                <div className="contentSection">
                                    <Grid container={true} spacing={24} className="surveyReportGridCss">
                                        <Grid item={true} xs={12}>
                                            <div className="media-list-wrapper">
                                                <Grid container={true} spacing={24}>
                                                 
                                                    <Grid item={true} xs={12}>
                                                        <div className="media-content">
                                                            {
                                                                this.state.reportIframeSrc !== "OtherDocument" ?
                                                                    <>
                                                                        {
                                                                            <iframe src={this.state.reportIframeSrc} height="950" width="100%"  className="" frameBorder="0" allowFullScreen={true} />
                                                                        }
                                                                    </>

                                                                    :
                                                                    <div className="invalidReport">
                                                                        No Report Found
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="media-content">
                                                            <div className="invalidReport">
                                                            {this.state.reportNameList.map((reportNameList: any) => (
                                                                <div key={reportNameList.id}>
                                                                    <div onClick={this.redirectToReport.bind(this, reportNameList.id)}>
                                                                        <h5 className="CustomCssForReports media-body">{reportNameList.reportName}</h5>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </Grid>

                                </div>

                            </div>
                        </> : <>
                            <div className="pageHeading">
                                <Grid container={true} spacing={8}>
                                    <Grid item={true} xs={6}>
                                        <div className="pageTitleSection">
                                            <IconButton onClick={this.back} className="backButton" color="inherit" aria-label="Open drawer">
                                                <IconBackButton />
                                            </IconButton>
                                            <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle strongText">
                                                Download Reports
                                            </Typography>


                                        </div>
                                        <Typography component="h2" align="left" gutterBottom={true} className="pageSubTitle">
                                            Click on each report to download
                                </Typography>

                                    </Grid>
                                </Grid>
                            </div>

                            <div className="pageContent">

                                <div className="contentSection">
                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} xs={12}>

                                            <div className="media-list-wrapper">

                                                <Grid container={true} spacing={24}>

                                                <Grid item={true} xs={3}>
                                                        <div className="media-list" onClick={this.handleDownloadOtherDocuments.bind(this, 5)}>

                                                            <div className="media-content">
                                                                <div className="media-left media-box media-box-primary media-box-large">
                                                                    <img src={NutriDashReport2018} alt="Union Logo" height="200px" width="200px" />
                                                                </div>

                                                                <div className="media-body">
                                                                    <h5 className="mt-0">NutriDash Report 2018</h5>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Grid>

                                                    <Grid item={true} xs={3}>
                                                        <div className="media-list" onClick={this.handleDownloadOtherDocuments.bind(this, 4)}>

                                                            <div className="media-content">
                                                                <div className="media-left media-box media-box-primary media-box-large">
                                                                    <img src={NutriDashReport2017} alt="Union Logo" height="200px" width="200px" />
                                                                </div>

                                                                <div className="media-body">
                                                                    <h5 className="mt-0">NutriDash Report 2017</h5>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Grid>

                                                    <Grid item={true} xs={3}>
                                                        <div className="media-list" onClick={this.handleDownloadOtherDocuments.bind(this, 3)}>

                                                            <div className="media-content">
                                                                <div className="media-left media-box media-box-primary media-box-large">
                                                                    <img src={NutriDashReport2015} alt="Union Logo" height="200px" width="200px" />
                                                                </div>

                                                                <div className="media-body">
                                                                    <h5 className="mt-0">NutriDash Report 2015</h5>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Grid>

                                                    <Grid item={true} xs={3}>
                                                        <div className="media-list" onClick={this.handleDownloadOtherDocuments.bind(this, 2)}>

                                                            <div className="media-content">
                                                                <div className="media-left media-box media-box-primary media-box-large">
                                                                    <img src={NutriDashReport2014} alt="Union Logo" height="200px" width="200px" />
                                                                </div>

                                                                <div className="media-body">
                                                                    <h5 className="mt-0">NutriDash Report 2014</h5>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Grid>

                                                    <Grid item={true} xs={3}>
                                                        <div className="media-list" onClick={this.handleDownloadOtherDocuments.bind(this, 1)}>

                                                            <div className="media-content">
                                                                <div className="media-left  media-box media-box-primary media-box-large">
                                                                    <img src={NutriDashReport2013} alt="Union Logo" height="200px" width="200px" />
                                                                </div>

                                                                <div className="media-body">
                                                                    <h5 className="mt-0">NutriDash Report 2013</h5>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Grid>

                                                </Grid>

                                            </div>


                                        </Grid>
                                    </Grid>
                                </div>

                            </div>
                        </>

                }</div>
            </>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/reports/SurveyInternalReportsListComponent.tsx